import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { proposalStatusInfo, ProposalStatusInfo } from 'app/helpers/proposal-status';

/**
 * Selo de status do orçamento (Badge `status` do design system):
 * pílula sólida na cor do status, com ícone e palavra.
 * `fallbackLabel` é usado só se o código não for um status conhecido.
 */
@Component({
    selector: 'app-proposal-status-badge',
    template: `
        <span *ngIf="info; else unknown" class="oa-status oa-status--{{ info.key }}"
            [class.oa-status--sm]="size === 'sm'" [class.oa-status--col]="column"
            [class.oa-status--noicon]="!icon">
            <mat-icon *ngIf="icon" aria-hidden="true">{{ info.icon }}</mat-icon>{{ info.label }}
        </span>
        <ng-template #unknown>
            <span *ngIf="fallbackLabel" class="oa-status oa-status--noicon"
                [class.oa-status--sm]="size === 'sm'" [class.oa-status--col]="column">{{ fallbackLabel }}</span>
        </ng-template>
    `,
    styles: [':host { display: inline-flex; vertical-align: middle; }'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProposalStatusBadgeComponent {
    @Input() status: number | string | null | undefined;
    @Input() size: 'sm' | 'md' = 'md';
    @Input() column = false;
    @Input() icon = true;
    @Input() fallbackLabel = '';

    get info(): ProposalStatusInfo | null {
        return proposalStatusInfo(this.status);
    }
}
